<!-- =========================================================================================
    File Name: AllTransactionList.vue
    Description: All Transaction List table
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
  <div id="ag-grid-demo">
    <vx-card>

      <!-- TABLE ACTION ROW -->
      <div class="flex flex-wrap justify-between items-center">

        <!-- ITEMS PER PAGE -->
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ contacts.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : contacts.length }} of {{ contacts.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="contacts"
        rowSelection="single"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true">
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage" />
    </vx-card>
  </div>
</template>

<script>

import companyConfig from '@/company_config.json'
// import common from '@/views/Common.vue'
import { AgGridVue } from "ag-grid-vue"
// import contacts from '../ui-elements/ag-grid-table/data.json'


import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'

export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      searchQuery: '',
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'S.No',
          field: 'sno',
          width: 100,
          filter: "agNumberColumnFilter",
          /*
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          */
        },
        {
          headerName: 'Date',
          field: 'TransactionDateTxt',
          filter: "agDateColumnFilter",
          filterParams: {
            comparator: function(filterLocalDateAtMidnight, cellValue) {
              var dateAsString = cellValue;
              if (dateAsString == null) return -1;
              var dateParts = dateAsString.split('/');
              var cellDate = new Date(
                Number(dateParts[2]),
                Number(dateParts[1]) - 1,
                Number(dateParts[0])
              );

              if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
                return 0;
              }

              if (cellDate < filterLocalDateAtMidnight) {
                return -1;
              }

              if (cellDate > filterLocalDateAtMidnight) {
                return 1;
              }
            },
            browserDatePicker: true,
          },
          width: 150,
        },
        {
          headerName: 'Tax',
          field: 'TaxableId',
          filter: true,
          width: 100,
        },
        {
          headerName: 'Type',
          field: 'TransactionTypeName',
          filter: true,
          width: 150,
        },
        {
          headerName: 'From Ledger Name',
          field: 'CreditLedgerName',
          filter: true,
          width: 250,
          // pinned: 'left'
        },
        {
          headerName: 'To Ledger Name',
          field: 'DebitLedgerName',
          filter: true,
          width: 250,
          // pinned: 'left'
        },
        {
          headerName: 'Amount',
          field: 'Amount',
          filter: "agNumberColumnFilter",
          width: 125,
        },                
        {
          headerName: 'Reference No',
          field: 'ReferenceNumber',
          filter: true,
          width: 175,
        },        
        {
          headerName: 'Description',
          field: 'Description',
          filter: true,
          width: 250,
        },
      ],
    }
  },
  watch: {
    '$store.state.windowWidth'(val) {
      if(val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned('email', null);
      }
      else this.gridOptions.columnApi.setColumnPinned('email', 'left')
    }
  },
  computed: {
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 50
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    },
    contacts() {
      return this.$store.getters['allTransaction/dataList'];
    },    
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    }
  },
  beforeMount() {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');      
    }else{
      var server_url=companyConfig.apiURL;
      var getAllRecords = {};
      getAllRecords.token=this.$session.get('token');
      getAllRecords.list_url=server_url+'lib/api/transaction/transaction/lists';
      getAllRecords.list_where={
        "transaction_type" : "0"        
      };
      console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
      getAllRecords.loading=this.$vs.loading;
      getAllRecords.notify=this.$vs.notify;
      getAllRecords.http=this.$http;    
      this.$store.dispatch('allTransaction/loadAllRecords', getAllRecords);
    }
  },  
  mounted() {
    this.gridApi = this.gridOptions.api;
  }
}

</script>
